/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_RemoveInputs */

const vi_camera_location_remove = /** @type {(inputs: Camera_Location_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gỡ khỏi vùng`)
};

/**

* @param {Camera_Location_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_remove = /** @type {((inputs?: Camera_Location_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_remove(inputs)
});